import React from 'react';
import './SecurityInfoSection.css';

// An array of objects holding the data for each informational block.
// This makes the component clean and easy to update.
const infoBlocksData = [
    {
      id: 'bug-bounty',
      imgSrc: "https://sendbird.imgix.net/cms/Bug-bounty-program-partner-with-us-to-keep-Sendbird-safe.png",
      title: "Bug bounty program: partner with us to keep Sendbird safe",
      description: "Security is a shared responsibility—one we take seriously. We operate a public bug bounty program to proactively identify and resolve potential vulnerabilities. If you discover an issue, report it through our program, and we’ll work with you to address it swiftly.",
      linkText: "Visit our bounty page",
      linkHref: "",
      imageSide: "right" // This determines the layout
    },
    {
      id: 'docs',
      imgSrc: "https://sendbird.imgix.net/cms/Comprehensive-security-documentation-for-your-teams.png",
      title: "Comprehensive security documentation for your teams",
      description: "We understand security is top priority for our customers, and we have detailed guides on the security features available for our customers to secure their Sendbird implementation.",
      linkText: "Visit our secure docs",
      linkHref: "",
      imageSide: "left" // This determines the layout
    },
    {
      id: 'compliance',
      imgSrc: "https://sendbird.imgix.net/cms/soc-2.jpg",
      title: "Security compliance & accreditation",
      description: "Sendbird maintains a strong commitment to data security and privacy, which is reflected in our adherence to a variety of industry-leading compliance and privacy frameworks. These frameworks include but are not limited to GDPR, CCPA, HIPAA, and SOC 2 Type 2.",
      // No linkText or linkHref for this block, so the link won't render.
      imageSide: "right" // This determines the layout
    }
];

/**
 * A reusable sub-component that renders a single info block.
 * It takes a 'block' object as a prop to populate its content.
 */
const InfoBlock = ({ block }) => (
    <div className={`security-info-block-item layout-${block.imageSide}`}>
        <div className="security-info-block-image-wrapper">
            <img src={block.imgSrc} alt={block.title} loading="lazy" />
        </div>
        <div className="security-info-block-content-wrapper">
            <h3 className="security-info-block-title">{block.title}</h3>
            <p className="security-info-block-description">{block.description}</p>
            {/* Conditionally render the link only if linkText exists in the data */}
            {block.linkText && 
                <a href="/security" target="_blank" rel="noopener noreferrer" className="security-info-block-link">
                    {block.linkText}
                </a>
            }
        </div>
    </div>
);

/**
 * The main section component that iterates over the data array
 * and renders an InfoBlock for each item.
 */
function SecurityInfoSection() {
  return (
    <section className="security-info-section-wrapper">
      {infoBlocksData.map((block) => (
          <InfoBlock key={block.id} block={block} />
      ))}
    </section>
  );
}

export default SecurityInfoSection;